import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useFillProfileData(id) {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.super_admins.coaches.fill_profile_data(id))
      .then((response) => {
        setData(response.data.data);
      });
  }, []);

  return data;
}
